import { useState, useEffect, useRef } from "react";

export default function useScanner({ onScan, enabled = true }) {
  const [error, setError] = useState("");
  const bufferRef = useRef("");
  const lastKeyTimeRef = useRef(0);
  const enabledRef = useRef(enabled);

  useEffect(() => { enabledRef.current = enabled; }, [enabled]);

  // Keyboard scanner (barcode gun emulates rapid keypresses ending with Enter)
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!enabledRef.current) return;
      if (e.target.tagName === "INPUT" || e.target.tagName === "TEXTAREA") return;

      const now = Date.now();
      if (now - lastKeyTimeRef.current > 100) bufferRef.current = "";
      lastKeyTimeRef.current = now;

      if (e.key === "Enter") {
        const code = bufferRef.current;
        bufferRef.current = "";
        if (code.length < 3) return;
        onScan(code);
      } else if (e.key.length === 1) {
        bufferRef.current += e.key;
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [onScan]);

  return { error, setError };
}
